import NP, {IHash} from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {IAthlete, Location, SportType, Stage} from "./types";
import {loadFile} from "../1. Core/ScriptLoader";
import {hideWaiter, showWaiterAnyWay} from "../Entries/battlehtml";
import {getCurrentUser} from "../1. Core/UserInfo";
import {MAIN_SERVER_URL} from "../3. VideoEditor/types";

let moment = require('moment');


NP.RED_COLOR = '#E74342';
NP.BLUE_COLOR = '#2962FF';

const arrru = new Array('Я', 'я', 'Ю', 'ю', 'Ч', 'ч', 'Ш', 'ш', 'Щ', 'щ', 'Ж', 'ж', 'А', 'а', 'Б', 'б', 'В', 'в', 'Г', 'г', 'Д', 'д', 'Е', 'е', 'Ё', 'ё', 'З', 'з', 'И', 'и', 'Й', 'й', 'К', 'к', 'Л', 'л', 'М', 'м', 'Н', 'н', 'О', 'о', 'П', 'п', 'Р', 'р', 'С', 'с', 'Т', 'т', 'У', 'у', 'Ф', 'ф', 'Х', 'х', 'Ц', 'ц', 'Ы', 'ы', 'Ь', 'ь', 'Ъ', 'ъ', 'Э', 'э');
const arren = new Array('Ya', 'ya', 'Yu', 'yu', 'Ch', 'ch', 'Sh', 'sh', 'Sh', 'sh', 'Zh', 'zh', 'A', 'a', 'B', 'b', 'V', 'v', 'G', 'g', 'D', 'd', 'E', 'e', 'E', 'e', 'Z', 'z', 'I', 'i', 'J', 'j', 'K', 'k', 'L', 'l', 'M', 'm', 'N', 'n', 'O', 'o', 'P', 'p', 'R', 'r', 'S', 's', 'T', 't', 'U', 'u', 'F', 'f', 'H', 'h', 'C', 'c', 'Y', 'y', '`', '`', '\'', '\'', 'E', 'e');

const names = {
	'Sergey': "Сергей",
	'Aleksei': 'Алексей'
} as IHash<string>;

export function titleCaseWord(word: string) {
	if (!word) return word;
	return word[0].toUpperCase() + word.substr(1).toLowerCase();
}

export function cyrillToLatin(text: string)
{
	for (let i = 0; i < arrru.length; i++)
	{
		let reg = new RegExp(arrru[i], "g");
		text = text.replace(reg, arren[i]);
	}
	return text;
}

export function latinToCyrill(text: string)
{
	for (let n in names)
	{
		text = text.replace(n, names[n]);
	}

	for (let i = 0; i < arren.length; i++)
	{
		let reg = new RegExp(arren[i], "g");
		text = text.replace(reg, arrru[i]);
	}
	return text;
}

export function getWeightString(w: Weight)
{
	let type = NP.RM.getString(w.IsPro ? "Pro" : "Amateur"),
		 sex = NP.RM.getString(w.Sex == 1 ? "Male" : "Female"),
		 kg = getWeightShortString(w);

	if (w.Type == 'MMA')
		return `MMA - ${w.Name} (${kg} ${sex})`;

	return `${w.Name} (${kg} ${type} ${sex})`;
}

function getWeightShortString(w: Weight)
{
	if (!w.ValueKG)
		return "";
	let res = "";
	if (w.Sex == 1)
	{
		if (w.ValueKG > 91)
			res = '91+';
		else
			res = w.ValueKG + NP.RM.getString("Kilogram");
	}
	else
	{
		if (w.ValueKG > 81)
			res = '81+';
		else
			res = w.ValueKG + NP.RM.getString("Kilogram");
	}
	return res;
}

export function getWeightStringById(weightId: number)
{
	for (let key in weights)
	{
		let res = weights[key].find(w => w.Id == weightId);
		if (res)
			return res.IsPro ? res.Name : getWeightShortString(res)
	}
	return '';
}

interface IState {
	Id: number,
	Name: string,
	NameRU: string,
	ISO: string
}

let states: IHash<IState[]> = {};

export async function getStates(countryId: number): Promise<IState[]>
{
	if (!states[countryId])
		states[countryId] = await ServerAPI.callUiApi("/locations/states?countryId=" + countryId);

	if (getCurrentUser().getUILang() == 'ru')
		states[countryId].forEach(state =>
		{
			if (state.NameRU)
				state.Name = state.NameRU
		})

	return states[countryId];
}

// let regions: IState[] = null;
//
// export function getRegions()
// {
// 	return new Promise((resolve) =>
// 	{
// 		if (!regions)
// 			ServerAPI.call("SportService.getRegions").then((res: IState[]) =>
// 			{
// 				regions = res;
// 				resolve(res);
// 			});
// 		else
// 			resolve(regions);
// 	});
// }

let countriesCache = {
	'true': null
} as IHash<IState[]>;

export function getCountries(all: boolean)
{
	return new Promise((resolve) =>
	{
		if (!countriesCache[all + ""])
			ServerAPI.get("/locations/countries").then((res: IState[]) =>
			{
				countriesCache[all + ""] = res;
				if (getCurrentUser().getUILang() == 'ru')
					res.forEach(state =>
					{
						if (state.NameRU)
							state.Name = state.NameRU
					})
				resolve(res);
			});
		else
			resolve(countriesCache[all + ""]);
	});
}


export interface ITournament {
	Id?: number;
	Name: string;
	Date?: string;
	Place?: string;
	UserInRaiting?: boolean;
	PermissionId?: number;
	IsPro?: boolean;
	IsAvailable?: boolean;
	Type: SportType,
	LogoUrl: string
	Current: string
}

let tournaments: ITournament[] = null;

export function clearAllTournaments()
{
	tournaments = null;
}

export function getTournaments(type: SportType)
{
	return new Promise((resolve) =>
	{
		if (tournaments && tournaments.length)
			if (tournaments[0].Type != type)
				tournaments = null;

		if (!tournaments)
			ServerAPI.callUiApi(`/tournaments?type=${type}`).then((res: ITournament[]) =>
			{
				tournaments = res;
				resolve(res);
			});
		else
			resolve(tournaments);
	});
}

export type Weight = {
	Id: number;
	ValueKG: number;
	ValueF: number;
	Sex: number;
	Name: string;
	IsPro: boolean;
	Type: SportType;
	f: () => {}
};

let weights: IHash<Weight[]> = {};

export function getWeights(filter?: { Sex?: boolean, IsPro?: boolean, Type?: SportType })
{
	if (!filter)
		filter = {Type: SportType.MMA}
	return new Promise((resolve) =>
	{
		let type = filter?.Type || SportType.MMA;
		if (!weights[type])
			ServerAPI.post("/weight/items", filter).then((res: Weight[]) =>
			{
				res.forEach(w =>
				{
					if (!weights[w.Type])
						weights[w.Type] = [];
					weights[w.Type].push(w)
				})
				resolve(weights[type]);
			});
		else
			resolve(weights[type]);
	});
}


export function getStages()
{
	return [
		Stage.Maincard,
		Stage.Statistics,
		Stage.Prelims,
		Stage.EarlyPrelims,
		Stage.Final,
		Stage.Stage_32,
		Stage.Stage_16,
		Stage.Stage_8,
		Stage.Stage_4,
		Stage.Stage_2
	];
}

// let associations: string[];
//
// export function getAssociations()
// {
// 	return new Promise((resolve) =>
// 	{
// 		if (!associations)
// 			ServerAPI.call("SportService.getAssociations").then((res: string[]) =>
// 			{
// 				associations = res;
// 				resolve(res);
// 			});
// 		else
// 			resolve(associations);
// 	});
// }

export interface IBattleEvent {
	BattleId?: number;
	Round: number;
	Sequence?: number;
	ActionAthleteId?: number;
	AnswerAthleteId?: number;
	TimeSegment?: number;
	Action: string;
	Answer?: string;
	IsSaved?: boolean;
	EventOrder?: number;
	ActionTS: string
	Time: string
}

export enum AttackType {
	J = "Jeb",
	LeftJab = "LeftJab",
	RightJab = "RightJab",
	LeftCross = "LeftCross",
	RightCross = "RightCross",
	C = "Cross",
	HL = "Hook L",
	HR = "Hook R",
	UL = "Uppercut L",
	UR = "Uppercut R",
}

export enum BlockType {
	B = "Block",
	LeftB = "LeftBlock",
	CenterB = "CenterBlock",
	RightB = "RightBlock",
	U = "Away",
	N = "Dive down",
	W = "Footwork",
	CL = "Clinch",
}

NP.isTha = function ()
{
	return location.href.indexOf('/thailand') > -1;
};

export interface IWidget {
	Id?: number;
	Key?: string;
	Name: string;
	Page?: string;
	Type?: string;
	BattleType?: SportType;
	IsAvailable?: boolean;
	Visible?: boolean
}

let widgets: IWidget[] = null;

export async function getInternalWidgets(): Promise<IWidget[]>
{
	if (widgets)
		return widgets.filter(w => w.Visible);

	widgets = await ServerAPI.callUiApi('/widget/internal')
	return widgets.filter(w => w.Visible)
}


let locations: Location[];

export async function getLocations(): Promise<Location[]>
{
	if (!locations)
		locations = await ServerAPI.callUiApi("/locations");

	return locations
}

export function clearLocationsCache()
{
	locations = null;
}


export function getComputedCSSText(node: HTMLElement): string
{
	let currentStyles = document.defaultView.getComputedStyle(node, "");
	let cssText = getComputedCSSTextFromCSSProps(currentStyles);
	return cssText;
}

function getComputedCSSTextFromCSSProps(currentStyles: CSSStyleDeclaration): string
{
	let s = [];
	// @ts-ignore
	for (let propName of currentStyles)
	{
		let value = (currentStyles as any)[propName];
		if (propName === "inset" || propName === "right" && currentStyles.left || propName === "bottom" && currentStyles.top)
			continue;
		if (propName === "inline-size" && currentStyles.width)
			continue;
		if (propName === "block-size" && currentStyles.height)
			continue;
		if (typeof (value) == 'string' && value != "")
		{
			s.push(`${propName}: ${value}`);
		}
	}
	return s.join('; ') + ";";
}

/**
 * Перобразует количество секунд в формат hh:mm:ss. Если количество секунд меньше одного часа, то возвращает строку в формате mm:ss.
 * Например: secondsToTime(130) -> "02:10"
 *           secondsToTime(3662) -> "01:01:02"
 * @param seconds количество секунд
 */
export function secondsToTime(seconds: number): string
{
	if (seconds == 0)
		return '00:00'
	let h = Math.floor(seconds / 3600);
	seconds = seconds % 3600;
	let m = Math.floor(seconds / 60);
	let s = Math.floor(seconds % 60);
	let hStr = h > 0 ? ((h < 10 ? '0' : '') + h + ':') : '';
	return `${hStr}${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
}

/**
 *
 * @param seconds
 */
export function timeToSec(seconds: string): number
{
	let arr = seconds.split(":");
	return parseInt(arr[arr.length - 2]) * 60 + parseInt(arr[arr.length - 1]);
}


export function getCharColor(char: string)
{
	if (!char)
		return "#9E9E9E";
	let charCode,
		 colorMap = ["#F77D74", "#EF6393", "#BA69C8",
			 "#9677CD", "#7A86CB", "#65B6F6",
			 "#51C3F7", "#4FD0E1", "#4FB6AC",
			 "#83C786", "#AED582", "#D3E051",
			 "#FDD835", "#FFC826", "#FF8B66",
			 "#A28980", "#BCBCBC", "#91A5AE"
		 ];
	char = char[0].toUpperCase();
	charCode = char.toUpperCase().charCodeAt(0);
	if (charCode >= 65 && charCode <= 90)
		return colorMap[(charCode - 65) % colorMap.length];
	else
		return "#9E9E9E";
}


export async function export2pdf(node: HTMLElement,
											fileName = 'document',
											format = 'a3')
{
	showWaiterAnyWay();
	if (!(window as any).html2pdf)
	{
		await loadFile('html2pdf.js')
	}

	let html2pdf = (window as any).html2pdf;
	html2pdf().from(node).set({
		margin: [10, 0, 10, 0],
		filename: `${fileName}.pdf`,
		image: {type: 'jpeg', quality: 0.98},
		html2canvas: {scale: 2, useCORS: true},
		jsPDF: {format: format}
	}).save().then(() =>
	{
		hideWaiter();
	})
}

function prepareDownloadVideoLink(link: string, name: string, type: string)
{
	if (link.startsWith("http"))
		return link;

	if (window.location.href.indexOf(".bd-sport.com") > -1)
	{
		let vt = "";
		if (type)
			vt = "-" + type;
		return `${MAIN_SERVER_URL}/video/${link}.mp4?f=${name}${vt}.mp4`
	}

	return `/ui-api/video/getFile/${link}`
}


export function downloadVideoFile(url: string, name: string, type: string)
{
	if (url)
	{
		url = prepareDownloadVideoLink(url, name, type);
		const link = document.createElement("a");
		link.href = url;
		link.target = "_blank"
		link.download = 'video.mp4';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		return url
	}
}

export function calculateAge(birthday: Date)
{
	let ageDifMs = new Date().getTime() - birthday.getTime();
	let ageDate = new Date(ageDifMs);
	return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function calculateAgeFromString(birthday: string)
{
	if (!birthday)
		return '';
	let d = moment(birthday).toDate()
	return calculateAge(d)
}

export function moveItemInArray(arr: any[], moveIndex: number, moveToIndx: number)
{
	const element = arr.splice(moveIndex, 1)[0];

	arr.splice(moveToIndx, 0, element);
}

export function getViewName(a: IAthlete): string
{
	if (!a.FirstName && !a.LastName)
		return '';

	let res = "";

	if (!a.FirstName)
		res += a.LastName;

	if (a.LastName)
	{
		if (res)
		{
			res += " ";
		}

		res += a.LastName;
	}

	return res;
}
